import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'

import * as Utils from 'src/utils/chartsUtils'
import { useStyles } from '../styles'
import TableAAA from '../../Tables/TableAAA'

const MEITotalImportsCard = (props) => {
  const { table1, gMei1, selectedDate } = props
    const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Movilidad eléctrica individual</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <TableAAA array={table1} selectedDate={selectedDate} param="MES" />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <h3>Evolución total mercado</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(gMei1, 'Y', 'CANT', 'VARIACION', 'Año', 1)}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default MEITotalImportsCard
